module.exports = __webpack_public_path__ + "static/media/news1.dd3f39b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/news1.jpg
// module id = 20
// module chunks = 0